<template>
    <div>

        <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
            <el-form-item label="物品名称" prop="ssmc">
                <el-select v-model="from.ssmc" placeholder="请选择" style="width: 100%;" filterable>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="物品编号" prop="ssdz">
                <el-input v-model="from.ssdz" disabled style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="规格型号" prop="fzrdh">
                <el-select v-model="from.ssmc" placeholder="请选择" style="width: 100%;" filterable>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="颜色" prop="fzrdh">
                <el-select v-model="from.ssmc" placeholder="请选择" style="width: 100%;" filterable>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="借用人" prop="fzrdh">
                <el-select v-model="from.ssmc" placeholder="请选择" style="width: 100%;" filterable>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号码" prop="fzrdh">
                <el-input v-model="from.ssdz" disabled style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="借用时间" prop="fzrdh">
                <el-date-picker v-model="from.ssdz" type="date" placeholder="请选择" style="width: 100%;">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="是否需要归还" prop="fzrdh">
                <el-select v-model="from.ssmc" placeholder="请选择" style="width: 100%;" filterable>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="Add"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
                from: {
                    xmid: "",
                    ssmc: "",
                    ssdz: "",
                    fzrid: "",
                    fzrdh: ""
                }
            };
        },
        methods: {
            Return() {
                this.$parent.$parent.Return();
            },
            Add() {
                this.Return();
            }
        },
        created() {

        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// WpjcGl_add.vue?2427ec21